import { render, staticRenderFns } from "./AddressPopup.vue?vue&type=template&id=1bb3bb46&"
import script from "./AddressPopup.vue?vue&type=script&lang=ts&"
export * from "./AddressPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports